<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <rect width="9" height="20" rx="0.638889" fill="currentColor" />
        <rect x="11" width="9" height="20" rx="0.638889" fill="currentColor" />
    </svg>
</template>
